export default __webpack_public_path__ + "static/ASLA_Radia_1-c567c174e92e2ed944e987192abee838.png";